import { render, staticRenderFns } from "./datajob-detail.vue?vue&type=template&id=4a0bf3c0&"
import script from "./datajob-detail.vue?vue&type=script&lang=ts&"
export * from "./datajob-detail.vue?vue&type=script&lang=ts&"
import style0 from "./datajob-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports